require('./bootstrap');

window.$ = window.jQuery = require('jquery')
require('jquery-migrate')

window.HSUnfold = require('../themes/vendor/hs-unfold/dist/hs-unfold.min')

// Import modules...
import Vue from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.mixin({ methods: { route } });
Vue.use(InertiaPlugin);
Vue.use(PortalVue);
Vue.use(VueToast);

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_APP_GOOGLE_MAPS_API_KEY,
        libraries: 'places',
    },
})

const plugin = {
    install() {
        Vue.$toast = VueToast
    }
}

const app = document.getElementById('app');

new Vue({
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
}).$mount(app);
